import { type Comment } from '@webapp/models/Comment'
import { ApiClient } from '@webapp/services/api'

export const ENDPOINT = '/api/v3/comments/'

export const SPEND_REQUESTS_URL = ENDPOINT

export interface CreateCommentSchema {
  comment: string
  object_pk: number
  content_type: number
  user_url: string
}

export interface GetCommentsSchema {
  order_by?: string
  page_size?: number
}

export class CommentsAPI {
  static readonly getComments = (
    contentId: number,
    objectID,
    params: GetCommentsSchema = {
      order_by: 'id',
      page_size: 10,
    }
  ) => {
    return ApiClient.get<Comment[]>(`${ENDPOINT}`, {
      params: {
        ...params,
        content_type: contentId,
        object_pk: objectID,
      },
    })
  }

  static readonly createComment = (data: CreateCommentSchema) => {
    return ApiClient.post<any, Comment>(ENDPOINT, data)
  }
}
